import React, {memo} from 'react';
import {useTranslation} from 'react-i18next';
import clsx from 'clsx';

import ModalTeamContent from '../../euro-2020/components/modal-team-content';
import withSideModal from '../../euro-2020/hocs/with-side-modal';

import styles from './top-forwards-list.module.css';

const PlayerTeam = ({
  player,
  onTeamClick,
  isMobile
}) => (
  <div
    className={clsx(
      styles.playerCol,
      styles.colTeam,
      {
        [styles.colTeamMobile]: isMobile
      }
    )}
  >
    <img
      className={styles.playerCountryFlag}
      src={player.flagUrl}
      alt={player.team}
      width={34}
      height={24}
    />
    <span
      className={styles.playerCountryName}
      onClick={() => onTeamClick({
        id: player.teamId || '',
        countryCode: player.countryCode || '',
        teamName: player.team
      })}
    >
      {player.team}
    </span>
  </div>
);

const TopForwardsList = ({
  topForwards,
  toggleSideModal
}) => {
  const {t} = useTranslation();

  const onTeamClick = ({
    id: teamId,
    countryCode,
    teamName
  }) => toggleSideModal({
    isOpen: true,
    renderContent: () => <ModalTeamContent teamId={teamId} countryCode={countryCode} teamName={teamName} />
  });

  return (
    <div className={styles.table}>
      <div className={styles.headMobile} >
        <div className={styles.headColMobile}>
          {t('fifa2022.topForwardsWidget.placeNameTeam')}
        </div>
        <div className={styles.headColMobile}>
          {t('fifa2022.topForwardsWidget.goals')}
        </div>
      </div>
      <div className={styles.head}>
        <div className={styles.headCol}>
          {t('fifa2022.topForwardsWidget.place')}
        </div>
        <div
          className={clsx(
            styles.headCol,
            styles.colName
          )}
        >
          {t('fifa2022.topForwardsWidget.name')}
        </div>
        <div
          className={clsx(
            styles.headCol,
            styles.colTeam
          )}
        >
          {t('fifa2022.topForwardsWidget.team')}
        </div>
        <div className={styles.headCol}>
          {t('fifa2022.topForwardsWidget.goals')}
        </div>
      </div>
      <div className={styles.body}>
        <div>
          {topForwards.map((player, index) => (
            <div key={player.id} className={styles.player}>
              <div className={styles.playerCol}>
                <span className={styles.playerPlace}>{index + 1}</span>
              </div>
              <div
                className={clsx(
                  styles.playerCol,
                  styles.colName
                )}
              >
                <span>{player.name}</span>
                <PlayerTeam player={player} onTeamClick={onTeamClick} isMobile />
              </div>
              <PlayerTeam player={player} onTeamClick={onTeamClick} />
              <div
                className={
                  clsx(
                    styles.playerCol,
                    styles.playerGoals
                  )}
              >
                {player.goals}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

  );
};

export default memo(withSideModal(TopForwardsList));
